<template>
  <div>
    <div id="container">
      <div class="button-wrapper">
        <div class="vue-uploader">
          <el-button :id="selectfiles" size="medium" class="submitBtn" :disabled="this.selecBtnStatus">
            {{ title.selectBtn }}
          </el-button>
          <el-button type="primary" size="medium" :id="postfiles" class="submitBtn">
            <a href="javascript:void(0);" class='btn'>
              {{ title.uploadBtn }}
            </a>
          </el-button>
        </div>
        <ApeExcelTable ref="apeTable" :data="tableData" :columns="tableColumns" :loading="loadingStaus" />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import plupload from 'plupload'
import XLSX from 'xlsx'
import ApeExcelTable from "@/components/ApeExcelTable";

export default {
  components: {
    ApeExcelTable,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    multiSelection: {
      type: Boolean,
      default: false
    },
    dir: {
      type: String,
      default: ''
    },
    selectfiles: {
      type: String,
      default: null
    },
    postfiles: {
      type: String,
      default: null
    },
    ossfile: {
      type: String,
      default: null
    },
    company_id: {
      type: String,
      default: null
    },
    max_width: {
      type: Number,
      default: 0
    },
    max_height: {
      type: Number,
      default: 0
    },
    title: {
      type: Object,
      default: () => {
        return {
          selectBtn: "选择本地Excel文件",
          uploadBtn: "确定无误后，上传此表格数据",
        }
      }
    },
    beforeUpload: {
      type: Function,
    },
    // onSuccess: {
    //   type: Function,
    // },
    tableColumns: {
      type: Array
    },
    tableKeyMap: {
      type: Object
    },
    tableData: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      loadingStaus: false,
      sign: [],
      file: [],
      prograss: [],
      url: [],
      filename: '',   // 文件原始名
      arrUrl: [],
      tableDataArr: [],
      excelData: {
        header: null,
        results: null
      },
      selecBtnStatus: false,//控制"选择本地Excel文件"按钮是否禁用
    }
  },
  computed: {
  },
  // beforeMount() {
  //   this.api()
  // },
  mounted() {
    this.upload()
  },
  methods: {
    generateData({ header, results }) {
      this.selecBtnStatus = true;
      this.loadingStaus = true;
      this.tableDataArr = [];
      for(var item in results){
        if(results.hasOwnProperty(item)){
          if(!results[item].idCard){
            delete(results[item]);
            continue;
          }
        }
      }
      console.log(results,"resultsresultsresults")
      results.map(item => {
        let tmp = {};
        for (let key of Object.keys(item)) {
          tmp[this.tableKeyMap[key]] = item[key];
        }
        this.tableDataArr.push(tmp);
      });
      this.excelData.header = header
      this.excelData.results = this.tableDataArr
      this.excelData.results.forEach((item) => {
        for (const key in item) {
         if(key == 'undefined') {
           delete item[key]
         }
        }
      })
      this.onSuccess && this.onSuccess(this.excelData)
    },

    async onSuccess({ results, header }) {
      for (let i of Object.keys(results)) {
        let arr = Object.keys(results[i])
        if (arr.indexOf('id_number') > 0) {
          results[i]['is_sign'] = await this.getIsSign(results[i]['id_number'])
        }
      }
      this.$emit("handleSuccess",{ results, header })
      setTimeout(()=> {
        this.loadingStaus = false;
        this.selecBtnStatus = false;
      }, 1000)
    },
    // 通过身份证获取签约情况
    async getIsSign(idcard) {
      let status = await this.$api.getTaskSign({
        idcard: idcard
      })
      return status == 'success' ? '已签约' : '未签约'
    },
    //  api请求签名
    async api() {
      const ossDir = `${this.$config.ossAppDir}/${this.dir}`
      const res = await this.$api.getOssSign({dir: ossDir})
      if (res) {
        this.sign = res
        this.imgurl = res.host + '/'
      } else {
        this.$message.error('获取oss签名失败')
      }
    },
    handle_del_files() {
      this.file = []
    },
    // plupload 相关配置
    upload() {
      this.api()
      const uploader = new plupload.Uploader({
        runtimes: 'html5,flash,silverlight,html4', // 制定上传方式
        browse_button: this.selectfiles, // dom元素的id
        multi_selection: this.multiSelection,
        container: document.getElementById('container'),
        url: 'http://oss.aliyuncs.com',
        // 当Plupload初始化完成后触发监听函数参数
        init: {
          PostInit: () => {
            document.getElementById(this.postfiles).onclick = () => {
              if (this.excelData.results) {
                if (this.url.key) {
                  this.$emit('return_url', {
                    url: this.imgurl + this.url.key,
                    filename: this.filename
                  })
                }
              } else {
                this.$alert('请先选择Excel文件。', '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              }
              this.set_upload_param(uploader, '', false)
              return false
            }
          },
          // 当文件添加到上传队列后触发监听函数参数
          FilesAdded: (up, files) => {
            //  判断是否重复
            if (!this.file.includes(files[0].name)) {
              this.file.push(files[0].name)
              this.prograss.push({
                name: files[0].name,
                prograss: 0
              })
            }
            if (this.multiple === false) {
              this.file = this.file.slice(0, 1)
              uploader.files = uploader.files.slice(0, 1)
              // 读取Excel文件
              const reader = new FileReader();
              reader.onload = e => {
                let preview = this.result;
                const data = e.target.result
                const workbook = XLSX.read(data, { type: 'array' })
                const firstSheetName = workbook.SheetNames[0]
                const worksheet = workbook.Sheets[firstSheetName]
                const header = this.getHeaderRow(worksheet)
                const results = XLSX.utils.sheet_to_json(worksheet)
                this.generateData({ header, results })
              };
              reader.readAsArrayBuffer(files[0].getNative());
              return
            }
          },
          // 上传前
          BeforeUpload: (up, file) => {
            this.set_upload_param(up, file.name, true)
          },
          // 上传完成
          FileUploaded: (up, file, info) => {
            if (this.url.length) {
              this.url.forEach((val, index) => {
                const fileItem = file[index]
                this.$emit('return_url', {
                  url: this.imgurl,
                  filename: this.filename,
                  size: fileItem.size,
                })
              })
            } else {
              this.$emit('return_url', {
                url: this.imgurl  + this.url.key,
                filename: this.filename,
                size: file.size
              })
            }
          },
          Error: (up, args) => {
            this.$message.error('上传失败')
            this.$emit('return_url', 'error')
          }
        }
      })
      uploader.init()
    },
    set_upload_param(up, filename, ret) {
      this.filename = filename
      const time = new Date().getTime() + Math.random() * 1000
      let key
      if (this.company_id) {
        key = this.sign.dir + this.company_id + '/' + time + '.' + filename.split('.')[filename.split('.').length - 1]
      } else {
        key = this.sign.dir + time + '.' + filename.split('.')[filename.split('.').length - 1]
      }
      console.log('::UPLOAD->filename', filename)
      const sign = this.sign
      const new_multipart_params = {
        key,
        policy: sign.policy,
        OSSAccessKeyId: sign.accessid,
        success_action_status: '200', // 让服务端返回200,不然，默认会返回204
        signature: sign.signature,
      }
      // 设定缩放尺寸大小
      const resize = {
        width: this.max_width,
        height: this.max_height
      }
      !resize.width && delete resize.width
      !resize.height && delete resize.height
      const options = {
        url: sign.host,
        resize,
        multipart_params: new_multipart_params,
      }
      if (JSON.stringify(resize) == '{}') {
        delete options.resize
      }
      up.setOption(options)
      up.start()
      this.arrUrl = []
      if (this.multiple === true) {
        // 图片和视频
        // if (key.includes('.jpeg') || key.includes('.jpg') || key.includes('.png') || key.includes('.gif') || key.includes('.xls') || key.includes('.xlsx') || key.includes('.csv') || key.includes('.mp4')) {
        // }
      } else {
        // 图片和视频
        if (key.includes('.jpeg') || key.includes('.jpg') || key.includes('.png') || key.includes('.gif') || key.includes('.xls') || key.includes('.xlsx') || key.includes('.csv') || key.includes('.mp4')) {
          this.arrUrl.push({ key })
          this.url = this.arrUrl[0]
        }
      }
    },
    //  移出文件
    remove(index) {
      this.file.splice(index, 1)
      this.$emit('remove_file')
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
  }
}
</script>

<style lang='scss' scoped>
.btn {
  color: #fff;
  cursor: pointer;
  text-decoration:none
}
.submitBtn {
  margin-right: 10px;
}
.vue-uploader {
  display: flex;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  .file-item {
    position: relative;
    margin: 5px 10px;
  }
  .file-remove {
    position: absolute;
    right: 4px;
    display: none;
    top: 4px;
    width: 20px;
    height: 20px;
    font-size: 20px;
    text-align: center;
    color: white;
    cursor: pointer;
    line-height: 18px;
    border-radius: 100%;
    transform: rotate(45deg);
    background: rgba(0, 0, 0, 0.5);
  }
  .file-item:hover .file-remove {
    display: block;
  }
  .prograss {
    transition: all 0.5s;
    border-radius: 4px;
    background-color: rgb(92, 184, 92);
    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.14902) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.14902) 50%,
      rgba(255, 255, 255, 0.14902) 75%,
      transparent 75%,
      transparent
    );
    background-size: 40px 40px;
    box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
    box-sizing: border-box;
    height: 4px;
    margin: {
      bottom: 5px;
    }
  }
}
.netbar_logo {
  width: 100%;
  height: 100px;
  // background: red;
  margin: {
    bottom: 15px;
  }
  div {
    width: 100px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}
</style>